import styles from './order-section.module.scss';

import classNames from 'classnames';
import { PropsWithChildren, ReactNode, isValidElement } from 'react';
import { Typography } from '../../../components/typography/typography';

type OrderSectionProps = PropsWithChildren<{
  header?: ReactNode;
  className?: string;
}>;

export const OrderSection = ({ children, header, className }: OrderSectionProps) => {
  return (
    <div className={classNames(styles.orderSection, className)}>
      {!!header &&
        (isValidElement(header) ? (
          header
        ) : (
          <Typography type="text-md" weight="medium" className="text-grey-800">
            {header}
          </Typography>
        ))}
      {children}
    </div>
  );
};
